import type { CRealizationsTranslations } from "./pl";

export const de: CRealizationsTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine Projekte zum Anzeigen.",
  categoriesAria: "Projektkategorien Filter",
  allCategories: "Alle",
  readMore: "Ansehen ->",
  backToList: "<- Zurück zur Projektliste",
  aboutBrand: "Über die Marke",
  goals: "Herausforderungen und Ziele",
  benefits: "Kundennutzen",
  implementationProcess: "Wie die Implementierung verlief",
  description: "Informationen zum Projekt",
  solutions: "Arbeitsumfang",
  clientAboutRealization: "Kunde über das Projekt",
  gallery: "Galerie",
};
